import { i18n } from '@apps/main/modules/localization/localizationSetup';
import type { Location } from '@apps/main/new-desktop/modules/mapbox';

import type { UserLocation } from '../../models';

const { t } = i18n.global;

export function getDefaultLabel(): string {
  return t('planner.your_position');
}

export function mapUserLocationFromLocation(location: Location): UserLocation {
  return {
    country: location.country,
    name:
      location.locality ||
      location.subLocality ||
      location.postalTown ||
      location.country ||
      location.formattedAddress ||
      getDefaultLabel(),
    coordinates: {
      latitude: location.position.latitude,
      longitude: location.position.longitude,
    },
  };
}
